/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionMappingDto } from '../models/Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionMappingDto';
import type { Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsBlobDto } from '../models/Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsBlobDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PdfFormFieldFillupService {
  /**
   * @param termsAndConditionId
   * @returns Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsBlobDto OK
   * @throws ApiError
   */
  public static getApiCustomerApiBrokeragePdfFillByTermsAndCondition(
    termsAndConditionId?: string
  ): CancelablePromise<Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsBlobDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/customer/api/brokerage-pdf/fill-by-terms-and-condition',
      query: {
        termsAndConditionId: termsAndConditionId,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @returns string OK
   * @throws ApiError
   */
  public static getApiCustomerApiBrokeragePdfAvailableSources(): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/customer/api/brokerage-pdf/available-sources',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param formData
   * @returns string OK
   * @throws ApiError
   */
  public static postApiCustomerApiBrokeragePdfInputFields(formData?: {
    pdf?: Blob;
  }): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/customer/api/brokerage-pdf/input-fields',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param termsAndConditionId
   * @returns Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionMappingDto OK
   * @throws ApiError
   */
  public static getApiCustomerApiBrokeragePdfMapping(
    termsAndConditionId: string
  ): CancelablePromise<Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionMappingDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/customer/api/brokerage-pdf/mapping/{termsAndConditionId}',
      path: {
        termsAndConditionId: termsAndConditionId,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param requestBody
   * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
   * @throws ApiError
   */
  public static postApiCustomerApiBrokeragePdfMapping(
    requestBody?: Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionMappingDto
  ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/customer/api/brokerage-pdf/mapping',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }
}
